/** 场景文件序列化 / 导入校验（F-003）。导入走 zod 校验，非法配置被拦截（NF-008 / AC-F003-01）。 */
import { ExperimentConfigSchema } from '../core/config-schema';
import { RuleSchema } from '../strategy/rule-engine/rule-model';
import { buildExperimentConfig } from '../ui/store';
import type { SetupFields } from '../ui/store';

export interface ScenarioFile {
  readonly name: string;
  readonly setup: SetupFields;
}

/** 序列化当前草稿为可分享的 JSON。 */
export function serializeScenario(name: string, setup: SetupFields): string {
  return JSON.stringify({ name, setup } satisfies ScenarioFile, null, 2);
}

/**
 * 解析导入的场景文件并校验：
 * - 结构含 name + setup；
 * - setup 能构建出合法 ExperimentConfig（楼层/比例/容量等，NF-008）；
 * - rules（若有）符合规则模型。
 * 任一不通过即抛错，由 UI 提示。
 */
export function parseScenarioFile(text: string): ScenarioFile {
  const obj = JSON.parse(text) as Partial<ScenarioFile> & { setup?: unknown };
  const name = typeof obj.name === 'string' ? obj.name : '';
  const setup = obj.setup as SetupFields | undefined;
  if (!setup || typeof setup !== 'object') throw new Error('场景文件缺少 setup 字段');

  ExperimentConfigSchema.parse(buildExperimentConfig(setup)); // 场景/客流/模式合法性
  if (Array.isArray(setup.rules)) RuleSchema.array().parse(setup.rules);

  return { name, setup };
}
